import createAnimation from './common';
import createMoveTween from './move';

export {
  createAnimation,
  createMoveTween
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/scroll-animations/index.js